<template>
  <div id="jonard-main-catalogue" class="main-catalogue-grid" v-if="typeof this.rd.variations !== 'undefined'">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-lg-4 col-xl-3 catalogue-position">
          <div class="subcategory-filter-option" :class="toggle ? 'show' : ''">
            <div class="subcategory-filter-close" @click="toggleFilter()">
              <i class="fas fa-window-close" aria-hidden="true"></i>
            </div>
            <div class="filters" id="subcategory_sidebar_fixed" :class="toggle ? 'd-block' : ''">
              <div class="sticky-container filter_col">
                <div class="inductry-categories filter_type">
                  <template>
                    <CategoryFilter v-if="this.categoryView == 1" :initialSubCategory="initialSubCategory" :key="categoryFilterKey"
                      @applyCategoryFilters="applyCategoryFilters" @clearAllFilters="clearAllFilters"
                      @clearInitialSubCategory="onClearInitialSubCategory" v-bind:availableCategories="filteredCategories"
                      v-bind:categoryFilters="categoryFilters">
                    </CategoryFilter>
                    <IndustryFilter :initialSubIndustry="initialSubIndustry" :key="industryFilterKey"
                      @applyIndustryFilters="applyIndustryFilters" @clearAllFilters="clearAllFilters"
                      @clearInitialSubIndustry="onclearInitialSubIndustry" v-bind:availableIndustriesIds="filteredIndustries"
                      v-bind:industryFilters="industryFilters">
                    </IndustryFilter>
                  </template>
                </div>
                <div class="industry-sub-category filter_type">
                  <template>
                    <SubIndustryFilter :selectedSubIndustry="selectedSubIndustry" @selectedIndustryFilter="selectedIndustryFilter"
                      @clearAllSubFilters="clearAllSubFilters" @applySubIndustryFilters="applySubIndustryFilters"
                      v-bind:availableSubIndustriesIds="filteredSubIndustries" v-bind:industrySubFilters="industrySubFilters"
                      v-if="this.attributesFilterEnable"  @toggleFilter="toggleFilter">
                    </SubIndustryFilter>
                  </template>
                  <div class="filters--clear">
                    <div class="subcategories-sidebar">
                      <h4><a data-toggle="collapse" href="#search_filter" role="button" aria-expanded="true" aria-controls="search_filter"  class="filter-toggle">Search</a></h4>
                      <div class="collapse show" id="search_filter">
                        <div class="seacrch_filter_box">
                          <TextSearch :key="textFilterKey" @textSearch="updateTextSearch"></TextSearch>
                          <button class="apply-filters" v-if="this.applyButton == 1" v-on:click="ApplyFilters()">Apply</button>
                          <button class="uncheck-all" @click="toggleFilter()">Search</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="sub-category-sort-filter">
                    <!-- <h4>Sort & Filter</h4> -->
                    <div class="filter-group">
                      <label>Sort By:</label>
                      <div class="sub-categories-select-wrapper">
                        <select v-model="activeFilters.sortBy" @change="ApplyFilters" class="form-control">
                          <option value="">Select...</option>
                          <option value="featured">Featured Products</option>
                          <option value="popular">Most Popular</option>
                          <option value="az">A to Z</option>
                          <option value="za">Z to A</option>
                        </select>
                      </div>  
                    </div>
                  </div>
                </div>
              </div>  
            </div>
          </div>
          <div id="popular-products-block" class="popular-products-block filter_type"></div>
        </div>
        <div class="col-md-12 col-lg-8 col-xl-9">
          <ProductList v-bind:variations="filteredVariations" v-bind:compare-enable="compareEnable"
            v-bind:compare-ids="compareIds" v-bind:header="productListHeader" v-bind:breadcrumbs="breadcrumbs"
            @toggleFilter="toggleFilter" @selectCompare="selectCompare"></ProductList>
          <CompareBlock v-if="compareEnable" v-bind:variations="compareVariations" v-bind:initial-category="initialCategory"
            v-bind:initial-industry="initialIndustry" @selectCompare="selectCompare"></CompareBlock>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>

  import CategoryFilter from './components/CategoryFilter.vue';
  import IndustryFilter from './components/IndustryFilter.vue';
  import TextSearch from './components/TextSearch.vue';
  import SubIndustryFilter from './components/SubIndustryFilter.vue';
  import ProductList from './components/ProductList.vue';
  import CompareBlock from './components/CompareBlock.vue'


  export default {
    name: 'jonard-main-catalogue',
    components: {
      CategoryFilter,
      IndustryFilter,
      TextSearch,
      SubIndustryFilter,
      ProductList,
      CompareBlock,
    },
    data() {
      return {
        settings: {},
        rd: {},             // Received data.
        activeFilters: {sortBy: '',}, // Used for filters that are dynamic.
        varIds: {},        // Filtered variation ids returned by filter components.
        categoryFilters: [],        // Filtered variation ids returned by filter components.
        industryFilters: [], 
        industrySubFilters: [],       // Filtered variation ids returned by filter components.
        initialIndustry: '0',        // Filtered variation ids returned by filter components.
        initialCategory: '0',
        selectedSubIndustry: '',        // Filtered variation ids returned by filte components.
        initialSubCategory: '',
        initialSubIndustry: '',        // Filtered variation ids returned by filter components.
        searchKey: this.$route.query.keys ? this.$route.query.keys : '',        // Search key from drupal settings.
        availableIndustriesIds: [],
        availableSubIndustriesIds: [],        // Filtered variation ids returned by filter components.
        variations: [],
        attributes: [],
        selectedVariationIds: [],  // Filtered variation ids
        compareEnable: this.$route.query.keys ? false : true, // Flag to enable compare.
        compareIds: [], // Used for compare products component.
        breadcrumbs: [], // Array of breadcrumb links.
        isSearchActive: this.$router.currentRoute.path === '/search',
        isCategoryPage: false,
        isIndustriesPage: false,
        attributesFilterEnable: false,
        industryFilterKey: 0,
        categoryFilterKey: 0,
        textFilterKey: 0,
        categoryView: 0,
        toggle: false,
        selectivefilters: [],
        applyButton: 0,
        viewsBlockLoaded: false,
        currentIndustryContext: '', // Add this to track current industry context
      };
    },
    created() {
      let params = {};
      if (this.$route.query.keys) {
        params['search_query'] = this.$route.query.keys;
      }
      if (drupalSettings.jonardCatalogue && drupalSettings.jonardCatalogue.industries) {
        params['industries'] = drupalSettings.jonardCatalogue.industries;
      }
      this.$http.get('/api/v1/products', {params: params}).then((resp) => {
            if (!resp.ok) {
              return;
            }

            this.rd = resp.body;

            const categories = this.rd.filters.taxonomy.product_category || [];
            const industries = this.rd.filters.taxonomy.industries || [];

            this.categoryFilters = categories.terms || [];
            this.industryFilters = industries.terms || [];
            this.industrySubFilters = industries.terms || [];
            this.variations = Object.values(this.rd.variations);
            this.attributes = Object.values(this.rd.filters.attributes);

            this.setInitialDataByRoute();
            this.applyFiltersByInitialData();
          }
      )
      ;
    },
    mounted() {
      // Use nextTick to ensure DOM is updated
      this.$nextTick(() => {
        this.attemptLoadViewsBlock();
      });
    },
    watch: {
      selectedVariationIds: function () {
        if (!this.isSearchActive && this.isCategoryPage) {
          const activeCategory = this.activeFilters.category.map(id => this.categoryFilters.find(filter => filter.id === id));
          this.breadcrumbs = activeCategory;
          this.$router.push(lastEl(activeCategory).alias);
        }
        if (!this.isSearchActive && this.isIndustriesPage) {
          const activeIndustry = this.activeFilters.industry.map(id => this.industryFilters.find(filter => filter.id === id));
          this.breadcrumbs = activeIndustry;
          this.$router.push(lastEl(activeIndustry).alias);
        }
      },
      'activeFilters.industry': {
        handler(newIndustry) {
          console.log('Industry filters changed:', newIndustry);
          if (newIndustry && newIndustry.length > 0) {
            // Get the last selected industry (most specific)
            const currentIndustry = newIndustry[newIndustry.length - 1];
            this.currentIndustryContext = currentIndustry;
            this.reloadViewsBlock();
          }
        },
        deep: true
      }
    }
    ,
    computed: {
      filteredVariations: function () {
        if (this.selectedVariationIds.length === 0) {
          return [];
        }

        // display all variations if no filters applied yet.
        if (Object.keys(this.activeFilters).length === 0) {
          return this.variations;
        }

        let filtered = this.variations.filter(variation => this.selectedVariationIds.includes(variation.id));
        // console.log(this.variation.featured);
        // Apply sorting
        if (this.activeFilters.sortBy) {
          switch (this.activeFilters.sortBy) {
            case 'featured':
              filtered.sort((a, b) => (parseInt(b.featured) || 0) - (parseInt(a.featured) || 0));
              break;
            case 'popular':
              filtered.sort((a, b) => (parseInt(b.view_count) || 0) - (parseInt(a.view_count) || 0));
              break;
            case 'az':
              filtered.sort((a, b) => a.title.localeCompare(b.title));
              break;
            case 'za':
              filtered.sort((a, b) => b.title.localeCompare(a.title));
              break;
          }
        }

        return filtered;
      }
      ,

      filteredCategories: function () {
        return this.categoryFilters.filter(cat => cat.parents.includes(this.initialCategory))
            .map(cat => {
              return {
                ...cat,
                counter: this.filteredVariations.filter(variation => variation.product_category.includes(cat.id)).length
              };
            }).sort(sortByWeight);
      }
      ,
      filteredIndustries: function () {
        return this.industryFilters
          .filter(ind => {
            return ind && ind.parents && Array.isArray(ind.parents) && 
                   ind.parents.includes(this.initialIndustry);
          })
          .map(ind => {
            return {
              ...ind,
              counter: this.filteredVariations.filter(variation => 
                variation.industries && 
                variation.industries.includes(ind.id)
              ).length
            };
          }).sort(sortByWeight);
      }
      ,
      filteredSubIndustries: function () {
        return this.industrySubFilters.filter(ind => ind.parents.includes(this.selectedSubIndustry))
            .map(ind => {
              return {
                ...ind,
                counter: this.filteredVariations.filter(variation => variation.industries.includes(ind.id)).length
              };
            }).sort(sortByWeight);
      }
      ,
      filteredAttributes: function () {
        const attrs = [];
        this.filteredVariations.forEach(variation => {
          const keys = Object.keys(variation);
          this.attributes.forEach(attr => {
            const attrKey = `attribute_${attr.id}`;
            if (keys.includes(attrKey)) {
              const found = attrs.find(found => found.id === attr.id);
              if (!found) {
                const values = [];
                variation[attrKey].forEach(key => {
                  values.push({key, value: attr.values[key], counter: 1});
                });
                attrs.push({...attr, values});
              }
              else {
                variation[attrKey].forEach(key => {
                  const foundValue = found.values.find(attrkey => attrkey.key === key);
                  if (!foundValue) {
                    found.values.push({key, value: attr.values[key], counter: 1});
                  }
                  else {
                    foundValue.counter++;
                  }
                });
              }
            }
          });
        });

        return attrs;
      },
      compareVariations: function () {
        return Object.values(this.rd.variations).filter(variation => {
          if (this.compareIds.includes(variation.id)) {
            return variation;
          }
        });
      },
      productListHeader: {
        cache: false,
        get() {
          let header = '';
          if (this.searchKey) {
            header = 'Search results for: "' + this.searchKey + '"';
          }
          else if (this.isIndustriesPage) {
            const activeIndustryId = lastEl(this.activeFilters.industry);
            header = this.industryFilters.find(found => found.id === activeIndustryId).label;
            header += ' (' + this.filteredVariations.length + ')';
          }
          else if (this.isCategoryPage) {
            const activeCategoryId = lastEl(this.activeFilters.category);
            header = this.categoryFilters.find(found => found.id === activeCategoryId).label;
            header += ' (' + this.filteredVariations.length + ')';
          }
          return header;
        }
      }
    },
    methods: {
      toggleFilter() {
        this.toggle = !this.toggle;
      },
      selectedIndustryFilter(filters_results){ 
        if(this.applyButton==1 && filters_results.length==0){
          this.applyButton = 0;
        }else{
          this.applyButton = 1;
        }
        this.selectivefilters = filters_results;
      },
      ApplyFilters(){
        this.toggleFilter();
        this.selectAttributes(this.selectivefilters);
      },
      selectAttributes(filters) {
        this.activeFilters.attributes = filters;
        this.selectedVariationIds = this.filterVariationsIds();
      },
      updateTextSearch(text) {
        this.activeFilters.keywordSearch = text;
        this.selectedVariationIds = this.filterVariationsIds();
      },
      applyCategoryFilters(filters) {
        if (filters.length > 1) {
          this.attributesFilterEnable = true;
          this.categoryFilters.filter(found => filters.includes(found.id)).forEach(item => {
            if (item.attributes_disabled === '1') {
              this.attributesFilterEnable = false;
            }
          }, this);
        }

        this.activeFilters.category = this.removeRootZeroCategories(filters);
        this.selectedVariationIds = this.filterVariationsIds();
      },
      applyIndustryFilters(filters) {
        this.selectedSubIndustry = filters[filters.length - 1];
        if (filters.length > 1) {
          this.attributesFilterEnable = true;
          this.industryFilters.filter(found => filters.includes(found.id)).forEach(item => {
            if (item.attributes_disabled === '1') {
              this.attributesFilterEnable = false;
            }
          }, this);
        }

        this.activeFilters.industry = this.removeRootZeroCategories(filters);
        this.selectedVariationIds = this.filterVariationsIds();
      },
      applySubIndustryFilters(filters) {
        if (filters.length > 1) {
          this.attributesFilterEnable = true;
          this.industrySubFilters.filter(found => filters.includes(found.id)).forEach(item => {
            if (item.attributes_disabled === '1') {
              this.attributesFilterEnable = false;
            }
          }, this);
        }

        this.activeFilters.industry = this.removeRootZeroCategories(filters);
        this.selectedVariationIds = this.filterVariationsIds();
      },
      onClearInitialSubCategory() {
        this.initialSubCategory = '';
      },
      onClearInitialSubIndustry() {
        this.initialSubIndustry = '';
      },
      onclearselectedSubIndustry() {
        this.selectedSubIndustry = '';
      },
      clearAllFilters() {
        this.toggleFilter();
        this.applyButton = 0;
        this.activeFilters = {sortBy: '',};
        this.varIds = {};

        if (this.isIndustriesPage) {
          this.categoryView = 0;
          this.applyIndustryFilters([this.initialIndustry]);
        }

        if (this.isCategoryPage) {
          this.categoryView = 1;
          this.applyCategoryFilters([this.initialCategory]);
        }

        this.industryFilterKey += 1;
        this.categoryFilterKey += 1;
        this.textFilterKey += 1;
        this.attributesFilterEnable = false;
      },
       clearAllSubFilters() {
        this.toggleFilter();

        if (this.isIndustriesPage) {
          this.categoryView = 0;
          this.applySubIndustryFilters([this.selectedSubIndustry]);
        }

        if (this.isCategoryPage) {
          this.categoryView = 1;
          this.applyCategoryFilters([this.initialCategory]);
        }
        this.attributesFilterEnable = true;
      },
      filterVariationsIds() {
        const keyword = this.activeFilters.keywordSearch || '';
        return [...Object
            .values(this.variations)
            .filter(variation => !this.activeFilters.category || this.activeFilters.category.every(v => variation.product_category.includes(v)))
            .filter(variation => !this.activeFilters.industry || this.activeFilters.industry.every(v => variation.industries.includes(v)))
            .filter(variation => {
              if (!this.activeFilters.attributes || this.activeFilters.attributes.length === 0) {
                return true;
              }
              return this.activeFilters
                  .attributes
                  .every(filter => variation[`attribute_${filter.attrId}`] && variation[`attribute_${filter.attrId}`]
                      .includes(filter.key));
            })
            .filter(variation => !keyword.trim() || (variation.title && variation.title.toUpperCase().includes(keyword.toUpperCase().trim())))
            .map(item => item.id)];
      },
      selectCompare(ids) {
        this.compareIds = ids;
      },
      setInitialDataByRoute() {
        const currentRoutePath = this.$router.currentRoute.path;
        const currentIndustry = this.industryFilters.find(term => term.alias === currentRoutePath);
        const currentCategory = this.categoryFilters.find(term => term.alias === currentRoutePath);
        console.log(currentRoutePath);
        console.log(currentCategory);
        if (currentCategory) {
          this.isCategoryPage = true;
          if (currentCategory.parents && Array.isArray(currentCategory.parents) && 
              currentCategory.parents.length > 0) {
            if (currentCategory.parents[0] === '0') {
              this.initialCategory = currentCategory.id;
            } else {
              this.initialSubCategory = currentCategory.id;
              this.initialCategory = currentCategory.parents[0];
            }
          } else {
            this.initialCategory = currentCategory.id;
          }
        }
        if (currentIndustry) {
          this.isIndustriesPage = true;
          if (currentIndustry.parents && Array.isArray(currentIndustry.parents) && 
              currentIndustry.parents.length > 0) {
            if (currentIndustry.parents[0] === '0') {
              this.initialIndustry = currentIndustry.id;
              this.currentIndustryContext = currentIndustry.id; // Set initial context
            } else {
              this.initialSubIndustry = currentIndustry.id;
              this.initialIndustry = currentIndustry.parents[0];
              this.currentIndustryContext = currentIndustry.id; // Set initial context
            }
          } else {
            this.initialIndustry = currentIndustry.id;
            this.currentIndustryContext = currentIndustry.id; // Set initial context
          }
        }
      },
      applyFiltersByInitialData() {
        if (this.isIndustriesPage) {
          const filters = this.initialSubIndustry
              ? [this.initialIndustry, this.initialSubIndustry]
              : [this.initialIndustry];
          this.applyIndustryFilters(filters);
          this.categoryView = 0;
        }

        if (this.isCategoryPage) {
          const filters = this.initialSubCategory
              ? [this.initialCategory, this.initialSubCategory]
              : [this.initialCategory];
          this.applyCategoryFilters(filters);
          this.categoryView = 1;
        }

        if (this.isSearchActive) {
          this.selectedVariationIds = this.filterVariationsIds();
        }
      },
      removeRootZeroCategories(categories) {
        return categories.filter(id => id !== "0");
      },
      attemptLoadViewsBlock(retryCount = 0) {
        console.group('Views Block Loading Debug');
        console.log('Attempting to load Views block, attempt:', retryCount + 1);
        
        const blockContainer = document.querySelector('[id="popular-products-block"]');
        console.log('Block container found:', blockContainer);
        
        if (typeof Drupal !== 'undefined' && blockContainer) {
          console.log('Drupal is available and block container exists');
          this.loadViewsBlock(blockContainer);
        } else {
          console.warn('Drupal not available or block container not found');
          
          // Retry up to 3 times with increasing delays
          if (retryCount < 3) {
            console.log(`Retrying in ${(retryCount + 1) * 500}ms...`);
            setTimeout(() => {
              this.attemptLoadViewsBlock(retryCount + 1);
            }, (retryCount + 1) * 500);
          } else {
            console.error('Failed to load Views block after multiple attempts');
            if (typeof Drupal === 'undefined') {
              console.warn('Drupal object is not defined - make sure Drupal is loaded before Vue');
            }
            if (!blockContainer) {
              console.warn('Block container element not found in DOM - check if the element exists and Vue has rendered it');
            }
          }
        }
        
        console.groupEnd();
      },
      
      loadViewsBlock(blockContainer) {
        console.group('Views Block Loading Process');
        console.log('Starting Views block load process with context:', this.currentIndustryContext);
        
        // Get all data-v attributes (there might be multiple for nested components)
        const dataVAttributes = Array.from(blockContainer.attributes)
          .filter(attr => attr.name.startsWith('data-v-'))
          .map(attr => attr.name);
        
        console.log('Found Vue scope attributes:', dataVAttributes);
        
        // Use the most specific selector possible
        const selector = dataVAttributes.length > 0 
          ? `[${dataVAttributes.join('][')}][id="popular-products-block"]`
          : 'popular-products-block';
        
        console.log('Generated selector:', selector);

        // Try loading the block directly first
        const blockConfig = {
          url: Drupal.url('system/ajax'),
          submit: {
            'system_ajax': 1,
            'block_id': 'jonard_views_block__popular_products_block_2',
            '_triggering_element_name': 'op',
            '_drupal_ajax': 1,
            'context': {
              'industry': this.currentIndustryContext
            }
          },
          success: (response, status) => {
            console.log('Block Response:', response);
            if (response && response[0] && response[0].data) {
              // Create a temporary container to parse the HTML
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = response[0].data;
              
              // Find the block content using the correct class
              const blockContent = tempDiv.querySelector('.block-jonard-views-blockpopular-products-block-2, .block-views-blockpopular-products-block-2');
              if (blockContent) {
                blockContainer.innerHTML = blockContent.innerHTML;
                console.log('Block content loaded successfully');
                
                // Reinitialize any Drupal behaviors
                if (Drupal.attachBehaviors) {
                  Drupal.attachBehaviors(blockContainer);
                }
              } else {
                console.warn('Block content not found in response, falling back to Views AJAX');
                console.log('Available HTML:', tempDiv.innerHTML);
                this.loadViewsBlockViaAjax(blockContainer, selector);
              }
            } else {
              console.warn('Invalid block response format, falling back to Views AJAX');
              this.loadViewsBlockViaAjax(blockContainer, selector);
            }
          },
          error: (response, status, error) => {
            console.error('Block loading error:', error);
            console.log('Falling back to Views AJAX due to error');
            this.loadViewsBlockViaAjax(blockContainer, selector);
          }
        };

        try {
          console.log('Attempting to load block directly with ID: jonard_views_block__popular_products_block_2');
          const blockAjax = Drupal.ajax(blockConfig);
          blockAjax.beforeSend = (xmlhttprequest, options) => {
            console.log('Block Request URL:', options.url);
            console.log('Block Request Data:', options.data);
          };
          blockAjax.execute();
        } catch (error) {
          console.error('Error loading block:', error);
          console.log('Falling back to Views AJAX due to error');
          this.loadViewsBlockViaAjax(blockContainer, selector);
        }
        
        console.groupEnd();
      },

      loadViewsBlockViaAjax(blockContainer, selector) {
        console.log('Falling back to Views AJAX loading with context:', this.currentIndustryContext);
        
        // Generate the view DOM ID that Drupal will use
        const cleanSelector = selector.replace(/\[data-v-[^\]]+\]/, '').replace(/[\[\]"]/g, '');
        const viewDomId = `.js-view-dom-id-${cleanSelector.replace(/=/g, '-')}`;
        console.log('Original selector:', selector);
        console.log('Clean selector:', cleanSelector);
        console.log('Generated view DOM ID:', viewDomId);
        
        const ajaxConfig = {
          url: Drupal.url('views/ajax'),
          submit: {
            view_name: 'popular_products',
            view_display_id: 'block_2',
            // Remove view_args and args[] and use the standard Views argument format
            'view_args': this.currentIndustryContext,
            'view_path': 'popular-products',
            'view_base_path': 'popular-products',
            'view_dom_id': selector,
            'pager_element': 0,
            '_drupal_ajax': 1,
            // Add the industry as a query parameter
            'industry': this.currentIndustryContext,
            // Add the contextual filter value
            'contextual_filter': this.currentIndustryContext
          },
          success: (response, status) => {
            console.log('Views AJAX Response:', response);
            
            // Process each command in the response
            if (Array.isArray(response)) {
              let foundInsertCommand = false;
              
              response.forEach((command, index) => {
                console.log(`Processing command ${index}:`, command);
                
                if (command.command === 'insert') {
                  console.log('Found insert command with selector:', command.selector);
                  console.log('Actual DOM ID in response:', command.selector);
                  
                  // Create a temporary container to parse the HTML
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = command.data;
                  console.log('Response HTML:', command.data);
                  
                  // Get all rows directly
                  const rows = tempDiv.querySelectorAll('.views-row');
                  console.log('Found rows:', rows.length);
                  
                  if (rows.length > 0) {
                    // Create a wrapper div to hold all rows
                    const wrapper = document.createElement('div');
                    wrapper.className = 'view-popular-products';
                    
                    // Create a view-content container
                    const viewContent = document.createElement('div');
                    viewContent.className = 'view-content';
                    
                    // Add each row to the view-content
                    rows.forEach(row => {
                      viewContent.appendChild(row.cloneNode(true));
                    });
                    
                    // Add view-content to wrapper
                    wrapper.appendChild(viewContent);
                    
                    // Set the content
                    blockContainer.innerHTML = wrapper.outerHTML;
                    console.log('Content loaded successfully with', rows.length, 'items');
                    foundInsertCommand = true;
                    
                    // Reinitialize any Drupal behaviors
                    if (Drupal.attachBehaviors) {
                      Drupal.attachBehaviors(blockContainer);
                    }
                  } else {
                    // Fallback to looking for other content
                    const possibleSelectors = [
                      '.view-popular-products',
                      '.view-content',
                      '.views-view-grid',
                      'section',
                      '.view',
                      '.block-views'
                    ];
                    
                    let content = null;
                    for (const sel of possibleSelectors) {
                      content = tempDiv.querySelector(sel);
                      if (content) {
                        console.log('Found content with selector:', sel);
                        blockContainer.innerHTML = content.outerHTML;
                        foundInsertCommand = true;
                        break;
                      }
                    }
                    
                    if (!content) {
                      console.warn('No content found with any selector. Available HTML:', tempDiv.innerHTML);
                    }
                  }
                }
              });
              
              if (!foundInsertCommand) {
                console.warn('No insert command found in response');
              }
            } else {
              console.warn('Invalid response format - expected array of commands');
            }
            
            // Log the final state
            const updatedBlock = document.querySelector(selector);
            console.log('Block after AJAX:', updatedBlock);
            console.log('Block content after AJAX:', updatedBlock ? updatedBlock.innerHTML : 'No content');
          },
          error: (response, status, error) => {
            console.error('Views AJAX Error:', {
              response: response,
              status: status,
              error: error
            });
          }
        };
        
        try {
          const ajaxObject = Drupal.ajax(ajaxConfig);
          ajaxObject.beforeSend = (xmlhttprequest, options) => {
            console.log('Views AJAX Request URL:', options.url);
            console.log('Views AJAX Request Data:', options.data);
          };
          ajaxObject.execute();
        } catch (error) {
          console.error('Error executing Views AJAX request:', error);
        }
      },
      reloadViewsBlock() {
        console.log('Reloading Views block with context:', this.currentIndustryContext);
        const blockContainer = document.querySelector('[id="popular-products-block"]');
        if (blockContainer) {
          this.loadViewsBlock(blockContainer);
        }
      }
    }
  };

  function lastEl(arr) {
    return arr[arr.length - 1];
  }


  function sortByWeight(a, b) {
    return a.weight - b.weight;
  }
</script>
